<h1 matDialogTitle>{{ modalTitle }}</h1>

<form [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content>
        <div *ngIf="!isStandardMachine && context.isNewEntry"
             class="machine-template">
            <p translate>machine_modal_form_floating_info</p>
        </div>

        <ng-container *ngIf="!context.isNewEntry">
            <mat-form-field>
                <input #licenseKeyInput
                       [readonly]="isLicenseKeyReadonly"
                       [placeholder]="'machine_modal_form_key' | translate"
                       matInput
                       formControlName="licenseKey"
                       name="licenseKey"
                       class="form-control"
                       data-cy="machine-key" />
                <span matSuffix>
                    <button [uiClipboard]="licenseKeyInput"
                            (clipboardSuccess)="clipboardCopied()"
                            mat-icon-button
                            [matTooltip]="'form_action_copy' | translate"
                            type="button">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </span>
            </mat-form-field>
        </ng-container>

        <mat-form-field>
            <input [placeholder]="(
                        isStandardMachine ?
                            'machine_modal_form_name_standard' :
                            'machine_modal_form_name_template'
                       ) | translate"
                   [readonly]="isNameReadonly"
                   [uiAutofocus]
                   matInput
                   formControlName="name"
                   name="name"
                   class="form-control"
                   required
                   data-cy="machine-name" />
            <mat-hint *ngIf="!form.get('name')!.pristine &&
                            form.get('name')!.hasError('maxlength')"
                      [translateParams]="{
                          max: form.get('name')!.getError('maxlength').requiredLength
                        }"
                      translate
                      class="errorMessage">
                machine_modal_name_max_warning
            </mat-hint>
        </mat-form-field>
        <mat-form-field>
            <input [placeholder]=" 'machine_modal_form_description' | translate"
                   matInput
                   formControlName="description"
                   name="description"
                   class="form-control"
                   data-cy="machine-description" />
            <mat-hint *ngIf="!form.get('description')!.pristine &&
                            form.get('description')!.hasError('maxlength')"
                      [translateParams]="{
                          max: form.get('description')!.getError('maxlength').requiredLength
                        }"
                      translate
                      class="errorMessage">
                machine_modal_description_max_warning
            </mat-hint>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button"
                data-cy="machine-cancel">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [uiAuthorize]="context.isNewEntry ? 'Machines.Create' : 'Machines.Edit'"
                [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="machine-submit">
            {{ (context.isNewEntry ? 'modal_action_provision' : 'modal_action_update') | translate }}
        </button>
    </mat-dialog-actions>
</form>
